<template>
  <TripsReport />
</template>
<script>
import { mapGetters } from 'vuex';

import TripsReport from "@/views/gekko/TripsReport.vue";

export default {
  name: "TripsReportMobile",
  components: {
    TripsReport
  },
  computed: {
    ...mapGetters({
      getMobileAppView: "main/getMobileAppView",
    })
  },
  created () {
    if (!this.getMobileAppView) {
      this.$router.push({ name: 'TripsReport' })
    }
  }
}
</script>
<style scoped lang="scss">

</style>
